/**
 * home.jsx
 * Home page of the wepsite
 */
import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Event from "./event";
import EventEditor from './eventEditor';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../../style/creationstyle.css";
import Contact from './contact';
import ContactEditor from './contactEditor';
import Popup from 'reactjs-popup';


/**
 * Home page of website
 * calls the rendering of all components for displaying and creating events and contacts
 */
function Home() {
    const[event,setEvent] = useState([]);
    const [contact,setContact] = useState([]);
    const [evetEditorOpen, setEventEditorOpen] = useState(true);
    const [contactEditorOpen, setContactEditorOpen] = useState(true);
    const [/*editEventData*/, setEditEventData] = useState(null);
    const [editContactData, setEditContactData] = useState(null);
    const [/*messageEvent*/, setMessageEvent] = useState(null);
    /**
    * Modal is the popup for the event editor
     */
    const Modal = () => (
        <Popup trigger={
            <span className="wrapperAdd">
                <img
                        className="eventCreateImg"
                        src={"https://res.cloudinary.com/imagefolder/image/upload/v1645301804/folder%20name/plusimage_dhx3ye.png"}
                        alt="..."
                        style={{wdith: "20%"}}
                        id="addEventImg"
                        />
                        <span className="tooltipevent">Add an Event</span>
            </span>} modal>
                            {close => (
                                <div>
                                    <button className="close" onClick={close}>
                                        &times;
                                    </button>
                                    <h2 className="header">Create an Event</h2>
                                    <Row>
                                    {!evetEditorOpen && (<Button variant="success" onClick={() => setEventEditorOpen(true)}>
                                                        </Button>)}

                                    {evetEditorOpen && (
                                    <EventEditor
                                    setEventEditorOpen={setEventEditorOpen}
                                    getEvent={getEvent}
                                    close={close}
                                    />
                                    )}
                                    </Row>
                                </div>
                            )}
                        </Popup>
    )

    useEffect(() => {
        //get events
        getEvent();
    },[]);

    useEffect(() =>{
        //get contacts
        getContact();
    },[]);
    /**
     * gets all current events assigned to a user
     */
    async function getEvent() {
        const eventRes = await axios.get("https://link2rsvp.herokuapp.com/event/");
        setEvent(eventRes.data);
    }
    /**
     * function getContact()
     * gets all current contacts assigned to a user
     */
    async function getContact() {
        const contactRes = await axios.get("https://link2rsvp.herokuapp.com/contact/");
        setContact(contactRes.data);
    }

    

    function editEvent (eventData) {
        setEditEventData(eventData);
        setEventEditorOpen(true);
        console.log(eventData);
    }

    function messageEventCon (event) {
        setMessageEvent(event);
        console.log(event);
    }


    function editContact (contactData) {
        setEditContactData(contactData);
        setContactEditorOpen(true);
    }
    /**
     * function renderEvent()
     * renders events assigned to a user
     */
    function renderEvent() {
        return (
            
                event.map((event,i) =>{ return <Event key={i}
                                                event={event}
                                                getEvent={getEvent}
                                                editEvent={editEvent}
                                                messageEventCon={messageEventCon}
                />
                
            })
        );
    }
    /**
     * function renderContac()
     * renders contacts assigned to a user
     */
    function renderContact() {
        return (
            contact.map((contact,i) => {return <Contact key={i} contact={contact} getContact={getContact}
            editContact={editContact}
            />
        })
    );
}


    return (
        <div className="home">
            <div className="px-4">
                <Row>
                    <Col id="left-col">
                        <div className="contacts">
                        <h1 className="colHeader">Contacts</h1>
                        {renderContact()}
                        {contactEditorOpen && (<ContactEditor
                        getContact={getContact}
                        assignedEvent={0}
                        editContactData={editContactData}
                        editContact={editContact}
                        />
                        )}
                        </div>
                    </Col>
                    <Col>
                        <div className="eventcreate">
                        <h1 className="colHeader">Events</h1>
                        <span>{renderEvent()}</span>
                            {Modal()}
                        </div>
                    </Col>
                </Row>
            </div>

        
            
        </div>
    ); 
}

export default Home;